const sessionSurvey = document.querySelectorAll('.survey-box');
if (sessionSurvey) {
  sessionSurvey.forEach((form, key) => {
    const radioButton = form.querySelectorAll('input[type=radio]');
    radioButton.forEach((radio) => {
      radio.addEventListener('click', (item) => {
        const id = radio.closest('.intra-session__item').getAttribute('id');
        window.location = `${localData.siteURL}?pageID=${localData.id}&key=${key}&action=saveUserResult&nonce=${sessionSurvey.nonce}&result=${item.target.id}#${id}`;
      });
    });
  });
}
